import { RiskProfileTier } from "./types";

/**
 * The submit API only returns a tier (risk_profile), not a score or
 * description — these are presentation-only constants for the result screen.
 */
export const TIER_DESCRIPTIONS: Record<RiskProfileTier, string> = {
  CONSERVATIVE:
    "A conservative profile trades returns for stability. Value stays within a narrow band: modest gains in strong years, limited losses in weak ones.",
  MODERATE:
    "A moderate profile trades some stability for returns. Value swings more than debt and less than equity, without extremes at either end.",
  AGGRESSIVE:
    "An aggressive profile trades stability for returns. Value can swing sharply both ways: large gains in strong years, deep falls in weak ones.",
};

/** Knob position (0-100) on the conservative -> aggressive meter. */
export const TIER_SCORES: Record<RiskProfileTier, number> = {
  CONSERVATIVE: 12,
  MODERATE: 52,
  AGGRESSIVE: 90,
};
